import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const htmlContainer = document.getElementById('root');
const objRoot = createRoot(htmlContainer);
objRoot.render(<App />)
